import { render, staticRenderFns } from "./promptDeposited.vue?vue&type=template&id=18d0df7a&scoped=true"
import script from "./promptDeposited.vue?vue&type=script&lang=js"
export * from "./promptDeposited.vue?vue&type=script&lang=js"
import style0 from "./promptDeposited.vue?vue&type=style&index=0&id=18d0df7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d0df7a",
  null
  
)

export default component.exports